module.exports = __webpack_public_path__ + "img/MR.fc68411a.png";